import type { Run, Task, User, PlannedRoute } from '@bringg/types';

export type GetWeightAndTotalWeightFunction = (
	tasks: Task[],
	run: Run,
	driver: User,
	plannedRoutes: PlannedRoute[]
) => any;

export class PackageWeightService {
	private weightAndTotalWeight: GetWeightAndTotalWeightFunction;

	attachWeightAndTotalWeightFunc = (getWeightAndTotalWeight: GetWeightAndTotalWeightFunction) => {
		this.weightAndTotalWeight = getWeightAndTotalWeight;
	};

	getWeightAndTotalWeight = (tasks: Task[], run: Run, driver: User, plannedRoutes: PlannedRoute[]) => {
		if (this.getWeightAndTotalWeight) {
			return this.weightAndTotalWeight(tasks, run, driver, plannedRoutes);
		}
	};
}

export const weightService = new PackageWeightService();
